import React, {useContext, useEffect, useState} from 'react';
import AppLayout from "../../components/layouts/app.layout";
import Navbar from "../../components/organisms/navbar/navbar";
import FormSection from "../../components/organisms/agencies/lists/form_section";
import 'react-perfect-scrollbar/dist/css/styles.css';
import AgenciesCards from "../../components/organisms/agencies/lists/cards";
import {AgenciesContext, AgenciesDispatcherContext} from "../../components/providers/agencies_provider";
import {isEmpty, str_replace} from "../../components/helpers/helpers";
import {getAgenciesPageBreadcrumbList, getAgenciesPageHotLinks, getAgenciesPageMetaTitleAnsDescription, getItemsLists} from "../../components/organisms/agencies/lists/helpers";
import BreadcrumbListSchema from "../../components/molecules/schema/breadcrumb_list_schema";
import {checkUrlParams, linkTypes} from "../../models/check_link";
import {Redirect} from "../../components/helpers/redirect";
import '@assets/scss/swiper/swiper.scss';
import {handleFooterLinks} from "../../components/organisms/footer/helpers";
import {handleNavbarLinks} from "../../components/organisms/navbar/helpers";
import {setDefaultCity} from "../../models/district";

const Agencies = ({city_id, district_id, page_type, ssrItems, breadcrumbList, ssrMetaTags, ssrHotlinks, navbarLinks, footerLinks, pageRobots}) => {
    const agenciesContext = useContext(AgenciesContext);
    const agenciesDispatcher = useContext(AgenciesDispatcherContext);

    const [hotLinksState, setHotLinks] = useState([]);
    const [pageMetaTags, setMetaTags] = useState({
        searchTitle: '',
        pageTitle: '',
        pageDescription: '',
        canonicalLink: '',
    });

    useEffect(() => {
        if (!isEmpty(ssrItems) && !isEmpty(ssrItems[page_type])) {
            const items = {
                [page_type]: ssrItems[page_type].lists,
                total: ssrItems[page_type].total,
            }

            dispatchItems(items, page_type, city_id, district_id, 1)
        } else if (!isEmpty(page_type) && !isEmpty(city_id)) {
            agenciesDispatcher({
                type: 'SET_SKELETON',
                payload: {
                    skeleton: true
                }
            });

            handleItemsLists(page_type, city_id, district_id);
        }

        if (isEmpty(ssrMetaTags) || isEmpty(ssrMetaTags.pageTitle)) {
            getAgenciesPageMetaTitleAnsDescription(city_id, district_id).then(metaTags => {
                setMetaTags(metaTags);
            }).catch(err => {
                console.log(err)
            })
        }

        if ((isEmpty(ssrHotlinks) || !ssrHotlinks.length) && !hotLinksState.length) {
            getAgenciesPageHotLinks(city_id, district_id).then(links => {
                setHotLinks(links);
            }).catch(err => {
                console.log(err)
            })
        }
    }, [city_id]);

    const handleItemsLists = (page_type, city_id, district_id, page, callback) => {

        getAgenciesPageMetaTitleAnsDescription(city_id, district_id).then(metaTags => {
            setMetaTags(metaTags);
        }).catch(err => {
            console.log(err)
        })

        getItemsLists(page_type, city_id, district_id, page, callback).then(res => {
            const {result, page_type, city_id, district_id, page, callback} = res;

            dispatchItems(result, page_type, city_id, district_id, page, callback)
        }).catch(err => {
            console.log(err)
        })

        if (page === 1) {
            getAgenciesPageHotLinks(city_id, district_id).then(links => {
                setHotLinks(links);
            }).catch(err => {
                console.log(err)
            });

            setDefaultCity(city_id, null); // save default city in cookie
        }
    }

    const dispatchItems = (items, page_type, city_id, district_id, page, callback) => {
        const dispatchType = (page_type === 'agencies') ? 'ADD_AGENCIES' : 'ADD_REALTORS';
        const newItems = page === 1 ? items[page_type] : [...agenciesContext[page_type].lists, ...items[page_type]];

        agenciesDispatcher({
            type: dispatchType,
            payload: {
                [page_type]: {
                    lists: newItems,
                    total: items.total,
                    hasMore: items.total > newItems.length,
                    page: page,
                },
                page_type: page_type,
                city_id: city_id,
                district_id: district_id,
            }
        });

        if (!isEmpty(callback)) {
            callback()
        }
    }

    const selectedCityId = (!isEmpty(agenciesContext) && !isEmpty(agenciesContext.city_id)) ? agenciesContext.city_id : city_id;
    const hotlinks = (hotLinksState.length) ? hotLinksState : ssrHotlinks;
    const {searchTitle, pageTitle, pageDescription, canonicalLink} = (!isEmpty(pageMetaTags) && !isEmpty(pageMetaTags.pageTitle)) ? pageMetaTags : ssrMetaTags;

    return (
        <AppLayout
            pageRobots={pageRobots}
            pageTitle={pageTitle}
            pageDescription={pageDescription}
            pageCanonicalLink={canonicalLink}
            footerLinks={footerLinks}
            selectedCityId={selectedCityId}
        >

            <Navbar
                selectedCityId={selectedCityId}
                navbarLinks={navbarLinks}
            />

            <div className="py-40 py-lg-56">

                <FormSection
                    searchTitle={searchTitle}
                    city_id={selectedCityId}
                    district_id={district_id}
                    page_type={page_type}
                    handleItemsLists={handleItemsLists}
                />


                <AgenciesCards
                    handleItemsLists={handleItemsLists}
                    ssrItems={ssrItems}
                    ssrPageType={page_type}
                    hotlinks={hotlinks}
                    selectedCityId={selectedCityId}
                />

            </div>

            {
                (!isEmpty(breadcrumbList) && breadcrumbList.length) &&
                <BreadcrumbListSchema params={breadcrumbList}/>
            }
        </AppLayout>
    );
};

Agencies.getInitialProps = async (context) => {
    const {res, req, asPath} = context;
    let pageRobots = 'index, follow, all';
    let pageType = 'agencies';
    let cityId = '';
    let districtId = '';
    let ssrItems = {};
    let breadcrumbList = [];
    let hotlinks = [];
    let searchTitle, pageTitle, pageDescription, canonicalLink, navbarLinks, footerLinks;

    if (!isEmpty(req) && !isEmpty(req.query) && !isEmpty(req.query.user_type) && req.query.user_type === 'realtor') {
        pageType = 'realtors';
        pageRobots = 'NOODP, nofollow, noindex';
    }

    if (!isEmpty(asPath)) {
        const checkUrl = await checkUrlParams(asPath, linkTypes.AGENCIES_LISTS);

        if (!isEmpty(checkUrl)) {
            if (!isEmpty(checkUrl.link) && checkUrl.redirect) {
                const redirectStatusCode = checkUrl.redirect_status_code ?? 301;
                const redirectLink = encodeURI(str_replace(process.env.NEXT_PUBLIC_APP_URL, '', checkUrl.link));

                return Redirect(context, redirectLink, redirectStatusCode);
            } else {
                const {city_id, district_id} = checkUrl;

                cityId = city_id;
                districtId = district_id
            }
        }
    }

    if (!isEmpty(pageType) && !isEmpty(cityId)) {
        const getItems = await getItemsLists(pageType, cityId, districtId, 1, null);
        const {result, page_type, city_id, district_id, page, callback} = getItems;

        ssrItems[pageType] = {
            lists: result[pageType],
            total: result.total,
            hasMore: result.total > result[pageType].length,
            page: page,
        }
    }

    if (!process.browser) {
        hotlinks = await getAgenciesPageHotLinks(cityId, districtId);

        breadcrumbList = getAgenciesPageBreadcrumbList(asPath);

        const pageMetaTags = await getAgenciesPageMetaTitleAnsDescription(cityId, districtId)

        searchTitle = pageMetaTags.searchTitle;
        pageTitle = pageMetaTags.pageTitle;
        pageDescription = pageMetaTags.pageDescription;
        canonicalLink = pageMetaTags.canonicalLink;

        if (!isEmpty(cityId)) {
            footerLinks = await handleFooterLinks(cityId);
            navbarLinks = await handleNavbarLinks(cityId);
        }
    }

    setDefaultCity(cityId, context); // save default city in cookie

    return {
        page_type: pageType,
        city_id: cityId,
        district_id: districtId,
        ssrItems: ssrItems,
        breadcrumbList: breadcrumbList,
        ssrMetaTags: {searchTitle, pageTitle, pageDescription, canonicalLink},
        ssrHotlinks: hotlinks,
        navbarLinks: navbarLinks,
        footerLinks: footerLinks,
        pageRobots: pageRobots
    }
}

export default Agencies;
